
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cloud-providers",
      function () {
        return require("private-next-pages/cloud-providers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cloud-providers"])
      });
    }
  